import { Global, css } from '@emotion/react';
import { baseFontSize, Breakpoint } from '../../config/styles';
import Header from '../Header';

const dark = '#0D0B2A';

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <Global
        styles={css`
          * {
            box-sizing: border-box;
          }

          html,
          body {
            -webkit-text-size-adjust: 100%;
            font-size: ${baseFontSize};
            font-optical-sizing: auto;
            background: ${dark};

            ${Breakpoint.tablet} {
              font-size: 14px;
            }
            ${Breakpoint.mobile} {
              font-size: 10px;
            }
          }

          body {
            margin: 0;
            font-variant: lining-nums;
            line-height: 1;
          }
        `}
      />
      <Header />
      {children}
    </>
  );
};

export default Layout;
